import { Suspense, type ReactNode } from 'react'
import { I18nextProvider } from 'react-i18next'
import i18n from '@/i18n'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { NavigationProvider } from '@/contexts/NavigationContext'
import { DesignProvider } from '@/contexts/DesignContext'
import { AuthProvider } from '@/contexts/AuthContext'
import { ToastProvider } from '@/contexts/ToastContext'
import { NotificationProvider } from '@/contexts/NotificationContext'
import { MarketProvider } from '@/contexts/MarketContext'
import { BootSkeleton } from '@/components/ui/BootSkeleton'

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <ToastProvider>
          <AuthProvider>
            <DesignProvider>
              <MarketProvider>
                <NavigationProvider>
                  <NotificationProvider>
                    <Suspense fallback={<BootSkeleton />}>{children}</Suspense>
                  </NotificationProvider>
                </NavigationProvider>
              </MarketProvider>
            </DesignProvider>
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </I18nextProvider>
  )
}
